import format from '@r1-frontend/ui-react/components/costs/Cost/format';

import { TCurrentTariff } from '~/src/features/tariffBuilder/types/TCurrentTariff';

export const currentTariffSummaryText = (currentTariff: TCurrentTariff) => {
    const currentTariffText = `Ваш текущий тариф стоит ${format(currentTariff.cost, { monthly: true })}`;
    const servicesText = currentTariff.services
        ? `, а&nbsp;за&nbsp;дополнительные услуги в&nbsp;прошлом месяце вы&nbsp;заплатили ${format(currentTariff.services.cost)}`
        : '';

    return `${currentTariffText}${servicesText}`;
};
